<template>
    <div class="ux-image" :class="className" :style="style">
        <object :alt="altText" v-if="svg" type="image/svg+xml" :data="src"></object>
        <img ref="img" :loading="loading" :alt="altText" v-else :style="imageStyle" :src="src" />
    </div>
</template>
<script>
function findClosestNumber(num, arr) {
    return arr.reduce((prev, curr) => {

        return Math.abs(curr - num) < Math.abs(prev - num) ? curr : prev;


    });
}


import _debounce from 'lodash/debounce';
export default {
    props: {
        item: {
            type: [Object, String],
        },
        alt: {
            type: String,
        },
        width: {
            type: [Number, String],
        },
        height: {
            type: [Number, String],
        },
        auto: {
            type: Boolean,
            default: true,
        },
        inline: {
            type: Boolean,
        },
        quality: {
            type: [Number, String],
        },
        contain: {
            type: Boolean,
            default: true,
        },
        preview: {
            type: Boolean,
            default: false,
        },
        crop: {
            type: Boolean,
        },
        cover: {
            type: Boolean,
        },
        format: {
            type: String,
        },
        upscale: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: 'image',
        },
        svg: {
            type: Boolean,
        },
        lazy:{
            type:Boolean,
        },
        eager:{
            type:Boolean,
        }
    },
    data() {
        return {
            model: this.item,
            retries: 0,
            cacheBuster: 0,
            retryTimer:null,
        }
    },
    watch: {
        item(m) {
            this.model = m;
        }
    },
    beforeMount() {
        this.$sdk.auth.ensureValidToken();
    },
    mounted() {

        // Ensure
        const img = this.$refs.img;
        if (img) {
            img.addEventListener('error', this.imageLoadError);
        }
    },
    beforeUnmount() {
        const img = this.$refs.img;
        if (img) {
            img.removeEventListener('error', this.imageLoadError);
        }
    },
    methods: {
        imageLoadError(e) {
            const self = this;

            // If there is an outstanding timer
            // kill it now
            if(self.retryTimer) {
                clearTimeout(self.retryTimer);
                self.retryTimer = false;
            }

            // Start a new timer
            self.retryTimer = setTimeout(function() {
                // Try again a few times
                if (self.retries < 5) {
                    self.cacheBuster++;
                    self.retries++;
                }

            }, 500)

        },
    },
    computed: {
        actualFormat() {

            const heicMimeType = this.item?.fileMime === 'image/heic';
            const heicExtension = this.item?.fileExtension === 'heic';

            // Always return png as browsers can't render heic
            if(heicMimeType || heicExtension) {
                return 'png';
            }

            return this.format;
        },
        loading() {
            if(this.lazy) {
                return 'lazy';
            }

            if(this.eager) {
                return 'eager';
            }
        },
        altText() {
            return this.alt || this.model?.title;
        },
        className() {

            var classes = [];

            // if(this.height || this.width) {
            //     classes.push('has-dimensions')
            // }

            // if(this.height > this.width) {
            //     classes.push('portrait');
            // } else if(this.height < this.width) {
            //     classes.push('landscape');
            // } else {
            //     classes.push('square');
            // }

            if (this.portrait) {
                classes.push('img-portrait')
            }

            return classes.join(' ');
        },
        isSvg() {
            if (this.svg) {
                return true;
            }

            switch (this.item?.fileMime) {
                case 'image/svg+xml':
                case 'image/svg':
                    return true;
                    break
            }
        },
        portrait() {
            return this.crop ? (this.dimensionHeight > this.dimensionWidth) : (this.modelHeight > this.modelWidth);
        },
        manualWidth() {
            return parseInt(this.width);
        },
        manualHeight() {
            return parseInt(this.height);
        },
        modelWidth() {
            return parseInt(this.model?.width);
        },
        modelHeight() {
            return parseInt(this.model?.height);
        },
        id() {
            return this.$sdk.utils.id(this.model);
        },
        params() {

            var params = {};
            params.access_token = this.$sdk.auth.getCurrentToken();
            params.cb = this.cacheBuster;

            /////////////////////////////////


            if (this.manualWidth) {
                params.w = this.manualWidth ? this.manualWidth : undefined;
            }

            if (this.manualHeight) {
                params.h = this.manualHeight ? this.manualHeight : undefined;
            }

            if (this.upscale) {
                params.u = true;
            }

            if (this.auto) {
                if (!params.w && !params.h) {
                    const imageMax = this.$sdk.app?.device?.image?.auto?.med;
                    if (imageMax) {
                        params.w = imageMax;
                        params.u = false;
                    }
                }
            }

            if (this.crop) {
                params.c = true;
            } else {
                if (!this.contain) {
                    params.c = Boolean(parseInt(this.manualWidth)) && Boolean(parseInt(this.manualHeight));
                }
            }

            if (this.quality) {
                params.q = parseInt(this.quality);
            }



            if (this.actualFormat) {
                params.f = this.actualFormat;
            }

            return params;
        },
        src() {

            const mediaType = 'image';
            const src = this.$sdk.api.generateEndpointURL(`/${mediaType}/${this.id}`, this.params, { file: true });
            return src;
        },
        previewSrc() {

            var params = Object.assign({}, this.params);
            params.w = 50;
            delete params.h;

            const mediaType = 'image';
            return this.$sdk.api.generateEndpointURL(`/${mediaType}/${this.id}`, params, { file: true });
        },
        imageStyle() {
            var style = {}

            if (!this.crop) {
                style['object-fit'] = 'contain';
            }

            if (this.cover) {
                style['object-fit'] = 'cover';
            }

            if (this.inline) {
                style.maxWidth = '100%';
            } else {

                style.width = '100%';
                style.height = '100%';
                style.top = `0`;
                style.left = `0`;
                style.position = 'absolute';

                // var transform = '';

                // if(this.crop) {
                //     style.width = '100%';
                // } else {

                //     if(this.portrait) {
                //         style.height = '100%';
                //     } else {
                //         style.width = '100%';
                //     }
                //         style.left = `50%`;
                //         transform += ` translateX(-50%) `;                    
                // }


                // if (this.dimensionHeight && this.dimensionWidth) {
                //         transform += ` translateY(-50%) `;
                //         style.top = `50%`;
                //         style.position = 'absolute';
                // }

                // style.transform = transform;
            }

            return style;
        },
        dimensionWidth() {
            if (this.manualHeight && this.manualWidth) {
                return this.manualWidth;
            }

            // if(this.manualHeight) {
            //     return;
            // }

            if (this.modelWidth && this.modelHeight) {
                return this.modelWidth;
            }


        },
        dimensionHeight() {

            if (this.manualHeight && this.manualWidth) {
                return this.manualHeight;
            }

            // if(this.manualWidth) {
            //     return;
            // }


            if (this.modelWidth && this.modelHeight) {
                return this.modelHeight;
            }


        },
        style() {

            var style = {};




            if (this.inline) {
                style.display = 'inline-block';
                // style.minHeight = this.dimensionHeight ? `${this.dimensionHeight}px` : undefined;
                // style.minWidth = this.dimensionHeight ? `${this.dimensionWidth}px` : undefined;
            } else {
                if (this.dimensionHeight && this.dimensionWidth) {
                    style.height = 0;
                    style.overflow = 'hidden';
                    style.paddingBottom = `${(this.dimensionHeight / this.dimensionWidth) * 100}%`;
                    style.position = 'relative';
                }
            }

            var colors = this.model?.fileMeta?.colors?.colors;
            if (colors && colors.length) {
                style.backgroundColor = colors[0];
            }



            // ///////////////////////////////////////////

            // if (this.manualWidth && this.manualHeight) {
            //     dimensionWidth = this.manualWidth;
            //     dimensionHeight = this.manualHeight;
            //     // style.width = `${dimensionWidth}px`;
            //     // style.height = `${dimensionHeight}px`;
            // }
            ///////////////////////////////////////////




            ///////////////////////////////////////////

            if (this.isSvg) {
                // No preview image
            } else {
                if (this.preview) {
                    style.backgroundImage = `url(${this.previewSrc})`
                }
            }

            ///////////////////////////////////////////

            return style;
        }
    },
}
</script>
<style lang="scss" scoped>
.ux-image {
    display: block;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    position:relative;
    // background-color: rgba(#000, 0.1);
    // overflow: hidden;


    img {
        // max-height:100%;
        display: block;
        margin: 0 auto;
        padding: 0;
    }

    // &.has-dimensions {
    //     width: 100%;
    //     height: 0;
    // }
}
</style>